enum USER_ROLE {
  admin_value = 1,
  user_value = 2,
  admin_label = "Admin",
  user_label = "Customer",
}

export { USER_ROLE };
